const MB_resourcePicker = async (): Promise<{ result?: any; error?: any }> => {
  console.warn('Warning: resource picker is not supported on web due to expo complications. Please use Dropzone resource picker on web');
  return { error: 'Use Dropzone for web' };
};

export { MB_resourcePicker };
